import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import { inject } from '@vercel/analytics'
import { installGlobalProperties } from './globalProperties'

console.log(`
_   __         ___  __
| | / /_ _____ / _ )/ /__  ___ ____ ____ ____
| |/ / // / -_) _  / / _ \\/ _ \`/ _ \`/ -_) __/
|___/\\_,_/\\__/____/_/\\___/\\_, /\\_, /\\__/_/
                        /___//___/

For geeks who wanted to write their blog site in Vue                 v0.1.0

Powered by %cVueBlogger%cv0.1.0%c

GitHub: https://github.com/samzhangjy/VueBlogger\nPlease star & fork to support the author!`,
'background-color: #1A55ED; padding: 7px; color: #fff;',
'background-color: #FCBF23; color: #000; padding: 7px;',
'font-weight: bold')

// 主入口:构造 app、注入全局属性、挂载
const app = createApp(App)
  .use(router)
  .use(PrimeVue, { theme: { preset: Aura } })
  .use({
    install: (a) => installGlobalProperties(a)
  })

// Vercel Web Analytics —— v2.x 自动 hook history API,SPA 路由跳转也会触发 beacon
// 部署到 Vercel 后才生效(非 Vercel 环境 inject() 是 no-op)
inject()

app.mount('#app')

// 路由切换后回滚到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})
